import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';

//Import Icons

// //Import Scrollbar
import SimpleBar from 'simplebar-react';

//Import images

//i18n

// MetisMenu
import MetisMenu from 'metismenujs';
import { Link, withRouter } from 'react-router-dom';

const DynamicMenu = (props: any) => {
  const { menus } = props;

  const ref = useRef<any>();
  const menuRef = useRef<MetisMenu | null>(null);
  // const { menus } = useSelector((state: any) => ({
  //   menus: state.auth.menus,
  // }));
  // console.log(menus);
  const defaultIcon = 'mdi mdi-format-list-bulleted';


  const activateMenuBranch = useCallback((item: HTMLAnchorElement) => {
    item.classList.add('active');

    let currentListItem = item.closest('li');

    while (currentListItem) {
      currentListItem.classList.add('mm-active');

      const parentList = currentListItem.parentElement;
      if (!parentList || parentList.id === 'side-menu') {
        break;
      }

      parentList.classList.add('mm-show');
      (parentList as HTMLElement).style.height = '';
      currentListItem = parentList.closest('li');
    }
  }, []);

  const closeMobileSidebar = () => {
    if (window.innerWidth <= 992) {
      document.body.classList.remove('sidebar-enable');
    }
  };

  const menusData: any = menus && menus.length > 0 ? menus : [];
  console.log(menusData)

  // Recreate the menu cleanly when its data or the current route changes.
  useEffect(() => {
    const ul = document.getElementById('side-menu');

    if (!ul) {
      return;
    }

    menuRef.current?.dispose();

    ul.querySelectorAll('.mm-active').forEach((element) => {
      element.classList.remove('mm-active');
    });
    ul.querySelectorAll('.mm-show').forEach((element) => {
      element.classList.remove('mm-show');
      (element as HTMLElement).style.height = '';
    });
    ul.querySelectorAll('a.active').forEach((element) => {
      element.classList.remove('active');
    });

    menuRef.current = new MetisMenu(ul);

    const navigableItems = Array.from(
      ul.querySelectorAll<HTMLAnchorElement>('a[data-sidebar-navigate="true"]'),
    );
    const matchingMenuItem = navigableItems.find(
      (item) => item.pathname === props.location.pathname,
    );

    if (matchingMenuItem) {
      activateMenuBranch(matchingMenuItem);
    }

    return () => {
      menuRef.current?.dispose();
      menuRef.current = null;
    };
  }, [props.location.pathname, menus, activateMenuBranch]);

  useEffect(() => {
    ref.current.recalculate();
  });


  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: '100%' }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title"> Menu </li>
            {/* <li>
              <Link to="/dashboard" className="">
                <i className="mdi mdi-home" />
                <span> Dashboard </span>
              </Link>
            </li> */}

            {menusData.length > 0 &&
              menusData.map(
                (menuItem: any) =>
                  // menuItem.name !== 'Dashboard' &&
                  menuItem.type.toLowerCase() === 'main-menu' && (
                    <li key={menuItem.id}>
                      <Link
                        to={
                          menuItem.url
                            ? menuItem.url + `?ref=${new Date().getTime()}`
                            : '#'
                        }
                        data-sidebar-navigate={Boolean(menuItem.url)}
                        onClick={menuItem.url ? closeMobileSidebar : undefined}
                        className={
                          menuItem.sub_menus &&
                          (menuItem.sub_menus?.length ?? 0) > 0 &&
                          !menuItem.url
                            ? 'has-arrow '
                            : ''
                        }
                      >
                        <i
                          className={
                            menuItem.icon_class_name
                              ? menuItem.icon_class_name
                              : defaultIcon
                          }
                        />

                        <span className="w-75 d-inline-flex">
                          <span className="text-truncate text-wrap" title={menuItem.name}>{menuItem.name}</span>
                        </span>
                      </Link>
                      {menuItem.sub_menus && (menuItem.sub_menus?.length ?? 0) > 0 && (
                        <ul className="sub-menu">
                          {menuItem.sub_menus.map(
                            (subMenuItem: any) =>
                              subMenuItem.name &&
                              // subMenuItem.url &&
                              subMenuItem.type.toLowerCase() === 'sub-menu' && (
                                <li key={subMenuItem.id}>
                                  <Link
                                    to={subMenuItem.url ? subMenuItem.url + `?ref=${new Date().getTime()}` : '#'}
                                    data-sidebar-navigate={Boolean(subMenuItem.url)}
                                    onClick={subMenuItem.url ? closeMobileSidebar : undefined}
                                    className={
                                      subMenuItem.url
                                        ? ''
                                        : 'disabled text-danger'
                                    }
                                  >
                                    <span className="w-100 d-inline-flex">
                                      <span>
                                        {subMenuItem.name}
                                      </span>
                                    </span>
                                  </Link>
                                </li>
                              ),
                          )}
                        </ul>
                      )}
                    </li>
                  ),
              )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

DynamicMenu.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(DynamicMenu);
